import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button } from '@mui/material';
import FormPage from '../components/FormPage';
import { register, fetchUsers } from '../services/ApiService';

export function AddTechnician() {
  const navigate = useNavigate();
  const [name, setName] = React.useState('');
  const [error, setError] = React.useState('');

  const handleCancel = () => navigate('/technicians');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const usersRes = await fetchUsers();
      const count = usersRes.data.filter((u) => u.department === 'Monit').length + 1;
      await register({
        name,
        email: `example${count}@example.com`,
        password: 'Monit',
        department: 'Monit',
      });
      navigate('/technicians', { state: { successMessage: 'Technician registered successfully' } });
    } catch (err) {
      const data = err.response?.data;
      const message = data && typeof data === 'object'
        ? Object.entries(data).map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`).join(' | ')
        : 'Registration failed. Please try again.';
      setError(message);
    }
  };

  return (
    <FormPage
      title="Register Technician"
      backTo="/technicians"
      onSubmit={handleSubmit}
      actions={<>
        <Button variant="outlined" onClick={handleCancel}>Cancel</Button>
        <Button variant="contained" type="submit">Register</Button>
      </>}
    >
      <TextField
        fullWidth
        required
        label="Full Name"
        placeholder="Enter technician's full name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        error={!!error}
        helperText={error}
      />
    </FormPage>
  );
}
